/**
 * UserType
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {TipoCliente} from '@/enums/TipoCliente'
import {UserTypeEnum} from '@/enums/UserTypeEnum'

/* TODO: review generated class */
export class UserType extends Resource {
  idUserTypePk: number = 0

  description: string | null = null

  get $id() {
    return this.idUserTypePk
  }
  set $id(val) {
    this.idUserTypePk = val
  }
  get $tag() {
    switch (this.$id) {
      case UserTypeEnum.SHIPPER:
        return String($.t('schema.UserType.shipper'))
      case UserTypeEnum.TRANSPORTER:
        return String($.t('schema.UserType.transporter'))
      case UserTypeEnum.HYBRID:
        return String($.t('schema.UserType.hybrid'))
      default:
        return ''
    }
  }
}
